import BaseApi from "./baseAPI";

class NotificationsAPI extends BaseApi{
    get entity() {
        return {
            route: `/notifications`,
            name: 'الاشعارات'
        }
    }
    markAsRead(){
        return new Promise((resolve, reject) => {
            return this.request.post(`${this.entity.route}/mark_as_read`)
                .then(response => resolve(this.responseWrapper(response)))
                .catch(error => reject(this.errorWrapper(error)))
        })
    }
}

export default new NotificationsAPI()
